import React from 'react'
import { NavLink } from "react-router-dom"
import { Breadcrumbs as BreadcrumbsComponent } from '@mantine/core'
import useBreadcrumbs from 'use-react-router-breadcrumbs'
import { Icon } from '@iconify/react';

import { NavContext } from 'src/components/navigation/NavContext'

type BreadCrumbsProps = {
    fontSize?: string;
    lineHeight?: string;
    color?: string;
    fontWeight?: number;
}

export const BreadCrumbs: React.FC<BreadCrumbsProps> = ({
    fontSize = '.8rem',
    lineHeight = '1rem',
    color = "var(--mantine-color-gray-7)",
    fontWeight = 400
}) => {

    const navContext = React.useContext(NavContext)
    const breadcrumbs = useBreadcrumbs(navContext.routes, { excludePaths: ["/"] })

    return (
        <div className="text-sm breadcrumbs">
            <BreadcrumbsComponent
                separator={<Icon icon="eva:chevron-right-fill" width={18} />}
                styles={{
                    separator: {
                        margin: 0
                    },
                    breadcrumb: {
                        color: color,
                        fontSize: fontSize,
                        lineHeight: lineHeight,
                        textDecoration: "none",
                        fontWeight: fontWeight
                    }
                }}
                style={{ marginBottom: 0 }}>
                {breadcrumbs.map((item, k) => {
                    return <NavLink key={`breadcrumb-${k}`} to={item.match.pathname}>{item.breadcrumb}</NavLink>
                })}
            </BreadcrumbsComponent>
        </div>
    )

}